import cacheSuggest from './cache';

import checkAjaxError from '@ott/helper-check-ajax-error';
import superagent from '@ott/superagent';

import T from '../types';
import countriesMap from '../../../dicts/countries';

const popularityComparator = (a, b) => b.popularity - a.popularity;

let req;
let prevSlug;

const suggest =
  ({ slug, text, mode, type, from, lang }) =>
  (dispatch, getState) =>
    dispatch({
      promise: async () => {
        const {
          railways: {
            suggest: {
              cache: { [mode]: { [from]: cachedValue } = {} },
            },
          },
        } = getState();

        if (!text && type) {
          return Promise.reject();
        }

        if (cachedValue) {
          return Promise.resolve({
            [slug]: cachedValue,
          });
        }

        if (req && slug === prevSlug) {
          try {
            req.abort();
            // eslint-disable-next-line no-empty
          } catch (e) {}
        }

        prevSlug = slug;
        const searchText = text && text.trim();

        req = superagent
          .get('/_railways/rzd/suggestStations')
          .query({
            searchText,
            type,
            mode,
            from,
            lang,
          })
          .withCredentials();

        try {
          // eslint-disable-next-line vars-on-top, no-var
          var { body } = await req;
        } catch (err) {
          return Promise.reject(checkAjaxError(err));
        }

        // eslint-disable-next-line block-scoped-var
        let { result } = body || {};

        result = (result || [])
          .map((item) => ({
            ...item,
            name: item.name.ru,
            countryCode: item.country,
            country: countriesMap[item.country],
          }))
          .sort(popularityComparator)
          .slice(0, 10);

        if (mode) {
          dispatch(cacheSuggest(result, mode, from));
        }

        return Promise.resolve({
          [slug]: result,
        });
      },
      slug,
      types: [T.SUGGEST_GET, T.SUGGEST_GET_SUCCESS, T.SUGGEST_GET_FAIL],
    });

export default suggest;
